import { retryFetch } from './RetryHelper';
import { debug } from 'src/logger';
import initialMetricsPublisher from "src/metrics";
import {INDEPENDENT_DEALER, NOT_PROVIDED} from "src/constants/DealershipInfoConstants";

export interface GetDealerSelectionDataRequest {
}

export interface GetDealerSelectionDataResponse {
    dealers: string[];
    dealerGroups: string[];
}

export const getDealerSelectionData =
    async (params: GetDealerSelectionDataRequest): Promise<GetDealerSelectionDataResponse> => {
        try {
            return await retryFetch(async () => {
                debug('Making GetDealerSelectionData Request:', params);
                const response = await fetch('/getstarted/api/getDealerSelectionData', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(params)
                });
                if (!response.ok) {
                    if (response.status === 429) {
                        const actionMetricsPublisher = initialMetricsPublisher.newChildActionPublisherForMethod('GetDealerSelectionDataCall');
                        actionMetricsPublisher.publishCounterMonitor('MonsServiceRateLimitCount', 1);
                    }
                    throw new Error('Encountered exception when calling GetDealerSelectionData')
                }

                const data = await response.json();
                debug('Received GetDealerSelectionData Response:', data);

                return {
                    dealers: [NOT_PROVIDED, ...data.dealers],
                    dealerGroups: [INDEPENDENT_DEALER, NOT_PROVIDED, ...data.dealerGroups]
                };
            });
        } catch (error) {
            console.error('Encountered exception calling GetDealerSelectionData');
            return { dealers: [], dealerGroups: [] };
        }
}
